var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"avg_marker",style:(_vm.markerStyle)},[(_vm.fitMode === 'width')?_c('div',{ref:"markerText",staticClass:"avg_text",style:({ left: -this.markerTextWidth + 10 + 'px' })},[_vm._v("\n    "+_vm._s('averageFold')+"\n  ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }